// Which style the category filter at the top of the booking page uses (experimental).
//
// Venues reported that customers do not notice the small filter buttons ("Tilat | Synttärit |
// Boksi-illat" at Boksi), so a venue can make them stand out with `experimental.categoryfilter`
// on its init doc:
//   'default' - the plain button group next to the date, as always (also when the value is
//               missing or unknown)
//   'tabs'      - a full-width row of tabs on its own row below the banners, right above the view
//                 buttons
//   'largetabs' - the same, bigger
// (A one-time glow was tried and dropped, 2026-10-30: it did not draw enough attention.)
// On test hosts (utest, localhost) `?catfilter=<value>` overrides the config, so every style can
// be compared on any venue without editing its init doc. Production ignores the parameter.

export const CATEGORY_FILTER_VARIANTS = ['default', 'tabs', 'largetabs']

const TEST_HOSTS = ['utest.cintoia.com', 'localhost']

const known = (value) => (CATEGORY_FILTER_VARIANTS.includes(value) ? value : null)

// location: { hostname, search } (window.location)
export const categoryFilterVariant = (appconfig, location) => {
  const loc = location || {}
  if (TEST_HOSTS.includes(loc.hostname)) {
    let fromUrl = null
    try {
      fromUrl = new URLSearchParams(loc.search || '').get('catfilter')
    } catch (e) {
      fromUrl = null
    }
    if (known(fromUrl)) return fromUrl
  }
  const configured = appconfig && appconfig.experimental && appconfig.experimental.categoryfilter
  return known(configured) || 'default'
}

export const hasTabs = (variant) => variant === 'tabs' || variant === 'largetabs'
